import React, { useState } from 'react';
import Paginations from '../common/paginations';
import constant from '../../constant';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { encodeBase64JsonPayload } from '../../utils';

const AppliedLeaveList = ({ data, setCurrentPage, limit, changeApplicationStatus, isAdmin, canEditApplications = isAdmin, onDelete }) => {
    const { leaves, pagination } = data;
    const { total, page } = pagination;

    const [statusMap, setStatusMap] = useState({});
    const [reasonMap, setReasonMap] = useState({});

    const handleStatusChange = (id, newStatus) => {
        setStatusMap(prev => ({ ...prev, [id]: newStatus }));
    };

    const handleReasonChange = (id, newReason) => {
        setReasonMap(prev => ({ ...prev, [id]: newReason }));
    };

    const handleSubmit = (item) => {
        const newStatus = statusMap[item.ID];
        const reason = reasonMap[item.ID] || '';
        changeApplicationStatus(item.ID, newStatus, reason)
    };

    return (
        <React.Fragment>
            <div className="table-responsive">
                <table className="table align-middle table-hover">
                    <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th scope="col">Employee Information</th>
                            <th scope="col">Leave Details</th>
                            <th scope="col">Status</th>
                            <th scope="col">Approved By</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {leaves?.length > 0 ? (
                            leaves.map((item, index) => (
                                <React.Fragment key={item.ID}>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontSize: 15, fontFamily: "nunito" }}>
                                            {(page - 1) * limit + index + 1}
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="#" className="text-dark">
                                                    {item.EMPLOYEE_NAME || item.FULL_NAME}
                                                </a>
                                            </h5>
                                            <p className="text-muted mb-0">
                                                {item.ROLE_NAME}{" "}
                                                <span className="badge border border-light rounded-circle bg-success p-1" />
                                            </p>
                                            <p className="text-muted mb-0">
                                                Site Location : <span style={{ color: "#ab5858" }}>{item.LOCATION_NAME}</span>
                                            </p>
                                        </td>
                                        <td>
                                            <p className="text-muted mb-0">
                                                No. of Days Applied For :{" "}
                                                <span style={{ color: "#e83e8c" }}>{item.TOTAL_DAYS} Days</span>
                                            </p>
                                            <p className="text-muted mb-0">
                                                Dates on Leave :{" "}
                                                <span style={{ color: "#e83e8c" }}>
                                                    {item.LEAVE_FROM} - {item.LEAVE_TO}
                                                </span>
                                            </p>
                                            <p className="text-muted mb-0">
                                                <i className="fa fa-sticky-note" style={{ fontSize: 16, color: "#50a5f1" }} />{" "}
                                                {item.NOTE || 'No reason provided'}
                                            </p>
                                            <p className="text-muted mb-0">
                                                <i className="fa fa-comment" style={{ fontSize: 16, color: "#50a5f1" }} />{" "}
                                                {item.REMARKS || 'No remarks'}
                                            </p>
                                        </td>
                                        <td>
                                            <span style={{
                                                color: item.STATUS === 'APPROVED' ? 'green' :
                                                    item.STATUS === 'REJECTED' ? 'red' :
                                                        item.STATUS === 'PENDING' ? '#ffc107' :
                                                            '#6c757d',
                                                fontWeight: 500
                                            }}>
                                                {item.STATUS}
                                            </span>
                                        </td>
                                        <td className="text-muted">
                                            {item.STATUS === 'APPROVED' ? (item.APPROVED_BY_NAME || '-') : '-'}
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-20 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <button
                                                        className={`btn btn-sm ${item.STATUS === 'PENDING' ? 'btn-warning' : 'btn-secondary'}`}
                                                        title={canEditApplications && item.STATUS === 'PENDING'
                                                            ? 'View details and approve/reject the leave'
                                                            : 'View leave details'}
                                                        data-bs-toggle="modal"
                                                        data-bs-target={`#leaveModal-${item.ID}`}
                                                    >
                                                        {canEditApplications && item.STATUS === 'PENDING' ? 'View & Approve/Reject' : 'View'}
                                                    </button>
                                                </li>
                                                {canEditApplications && <li className="list-inline-item px-2">
                                                    <Link
                                                        to={{
                                                            pathname: constant.Authedcomponent.leaveEdit.url,
                                                            state: {
                                                                data: encodeBase64JsonPayload(item),
                                                                page,
                                                                returnTo: constant.Authedcomponent.leaveApplications.url,
                                                            },
                                                        }}
                                                        title="Edit"
                                                    >
                                                        <i className="bx bx-edit text-primary" />
                                                    </Link>
                                                </li>}
                                                {isAdmin && <li className="list-inline-item px-2">
                                                    <button type="button" className="btn btn-link p-0 text-danger" title="Delete" onClick={() => onDelete(item.ID)}>
                                                        <i className="bx bx-trash" />
                                                    </button>
                                                </li>}
                                            </ul>
                                        </td>
                                    </tr>
                                    {/* Modal */}
                                    <div
                                        className="modal fade"
                                        id={`leaveModal-${item.ID}`}
                                        data-bs-backdrop="static"
                                        data-bs-keyboard="false"
                                        tabIndex={-1}
                                        role="dialog"
                                        aria-labelledby="leaveModalLabel"
                                        aria-hidden="true"
                                    >
                                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="leaveModalLabel">
                                                        Leave Application Details
                                                    </h5>
                                                    <button
                                                        type="button"
                                                        className="btn-close"
                                                        data-bs-dismiss="modal"
                                                        aria-label="Close"
                                                    />
                                                </div>
                                                <div className="modal-body">
                                                    <table className="table table-striped mb-3">
                                                        <tbody>
                                                            <tr>
                                                                <td>Employee Name</td>
                                                                <td>{item.EMPLOYEE_NAME || item.FULL_NAME}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Location</td>
                                                                <td>{item.LOCATION_NAME}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Leave Duration</td>
                                                                <td>{item.LEAVE_FROM} to {item.LEAVE_TO} ({item.TOTAL_DAYS} days)</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Reason</td>
                                                                <td>{item.NOTE || 'No reason provided'}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Remarks</td>
                                                                <td>{item.REMARKS || 'No remarks'}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Status</td>
                                                                <td>
                                                                    <span style={{
                                                                        color: item.STATUS === 'APPROVED' ? 'green' :
                                                                            item.STATUS === 'REJECTED' ? 'red' :
                                                                                item.STATUS === 'PENDING' ? '#ffc107' :
                                                                                    '#6c757d',
                                                                        fontWeight: 500
                                                                    }}>
                                                                        {item.STATUS}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    {/* Action section */}
                                                    {canEditApplications && item.STATUS === 'PENDING' && <><div className="mb-3">
                                                        <label className="form-label">Change Status</label>
                                                        <select
                                                            className="form-select"
                                                            value={statusMap[item.ID] || item.STATUS}
                                                            onChange={(e) => handleStatusChange(item.ID, e.target.value)}
                                                        >
                                                            <option value="PENDING" disabled>Pending</option>
                                                            <option value="APPROVED">Approve</option>
                                                            <option value="REJECTED">Reject</option>
                                                        </select>
                                                    </div>

                                                        <div className="mb-3">
                                                            <label className="form-label">Remarks (optional)</label>
                                                            <textarea
                                                                className="form-control"
                                                                rows="3"
                                                                placeholder="Add a remark or note"
                                                                value={reasonMap[item.ID] || ''} // <-- FIXED LINE
                                                                onChange={(e) => handleReasonChange(item.ID, e.target.value)} // already correct
                                                            />

                                                        </div>
                                                    </>}
                                                </div>
                                                {canEditApplications && item.STATUS === 'PENDING' && <div className="modal-footer">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success"
                                                        data-bs-dismiss="modal"
                                                        onClick={() => handleSubmit(item)}
                                                    >
                                                        Submit
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-light"
                                                        data-bs-dismiss="modal"
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>

                                </React.Fragment>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" className="text-center text-muted">No leave applications found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Paginations
                range={5}
                limit={limit}
                totalCount={total}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
        </React.Fragment>
    );
};

export default AppliedLeaveList;
